export default "__VITE_ASSET__DnkUHXWJ__"